import { render, staticRenderFns } from "./ObjectPossibleDeposits.vue?vue&type=template&id=5d77175c&scoped=true"
import script from "./ObjectPossibleDeposits.vue?vue&type=script&lang=js"
export * from "./ObjectPossibleDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d77175c",
  null
  
)

export default component.exports